<template>
  <v-app-bar
    :clipped-left="$vuetify.breakpoint.lgAndUp"
    app
    class="primary white--text"
  >
    <v-toolbar-title>
      <v-app-bar-nav-icon
        @click.stop="toggleMenu"
        class="white--text"
        v-if="$auth.isAuthenticated"
      ></v-app-bar-nav-icon>
      <v-icon v-if="!$auth.isAuthenticated" color="white" large>event</v-icon>
      <span class="hidden-sm-and-down headline pl-2 pt-1"></span>
        Reminder Notices
      </span>
    </v-toolbar-title>
    <div></div>
    <v-select
      style="margin-left: 2.2%; margin-top: 1%; width: 120px;"
      v-model="customerType"
      :items="items"
      :disabled="loading"
      placeholder="Select Customer Type"
      v-on:change="changeCustomerType"
      dark
    ></v-select>
    <v-text-field
      @keyup="search"
      flat
      :disabled="loading"
      solo-inverted
      hide-details
      prepend-inner-icon="search"
      v-model="searchKeyword"
      label="Search Customer Number, Company, Name, Email, etc."
      class="hidden-sm-and-down font-italic"
      style="margin-left: 2.2%;"
      dark
      v-if="$auth.isAuthenticated"
      color="black"
      clearable
      @click:clear="reset"
    ></v-text-field>

    <div class="flex-grow-1">
      <div v-if="$auth.isAuthenticated" class="float-right mr-4">
         <span class="text-muted font-weight-light px-2 body-1">
          {{ $auth.user.name }}
        </span>
        <v-btn @click="logout" class="font-weight-black" :disabled="loading">
          Logout
        </v-btn>
      </div>
    </div>
  </v-app-bar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { EventBus } from '../../plugins/event-bus.js'

export default {
  name: 'AppBar',
  data: () => ({
    drawer: null,
    searchKeyword: '',
    customerType: null,
    loading: false,
    items: ['Retail', 'Wholesaler-14 Days', 'Wholesaler-30 Days'],
    mfadialog:false
  }),
  methods: {
    ...mapActions('menu', ['updateMenuStatus']),
    ...mapActions('search', ['startSearch', 'resetKeyword']),
    toggleMenu() {
      this.updateMenuStatus().then(() => {})
    },
    search() {
      this.startSearch(this.searchKeyword).then(() => {})
    },
    logout() {
      this.$auth.logout({ returnTo: window.location.origin })
    },
    reset() {
      this.resetKeyword()
    },
    changeCustomerType() {
      EventBus.$emit('typeSelected', this.$data.customerType)
    },
    openMFADialog() {
      EventBus.$emit('toggleMFADialog' ,true)
    },

  },
  computed: {
    ...mapGetters('search', ['keyword']),
  },
  watch: {
    loading() {
      return this.loading
    },
  },
  created() {
    const vm = this
    EventBus.$on('isLoading', (val) => {
      vm.loading = val
    })
  },
}
</script>
<style lang="scss">
::-webkit-input-placeholder {
  caret-color: #ffffff !important;
}
</style>
